import { Chip, SxProps } from "@mui/material";
import ReportProblemOutlinedIcon from "@mui/icons-material/ReportProblemOutlined";
import { useTranslation } from "react-i18next";
import {
  colorSurfaceError,
  colorActionDanger,
  colorBorderError,
} from "src/design/tokens";

interface NoShowWarningIndicatorProps {
  count: number;
  sx?: SxProps;
}

// Inline warning chip surfaced next to a booker who has a recent no-show
// history. Rendered only when the booking carries `hasNoShowWarning` (the count
// alone does not justify warning staff).
export const NoShowWarningIndicator = ({
  count,
  sx,
}: NoShowWarningIndicatorProps) => {
  const { t } = useTranslation();

  return (
    <Chip
      icon={
        <ReportProblemOutlinedIcon
          sx={{ fontSize: 13, color: `${colorActionDanger} !important` }}
        />
      }
      label={t("bookings.noShowWarning.chip", { count })}
      size="small"
      sx={{
        backgroundColor: colorSurfaceError,
        color: colorActionDanger,
        border: `1px solid ${colorBorderError}`,
        fontWeight: 500,
        fontSize: "11px",
        height: "20px",
        borderRadius: "6px",
        "& .MuiChip-icon": { ml: "4px" },
        ...sx,
      }}
    />
  );
};
